/**
 * Import Dependency
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '@/store'

/**
 * Import Language
 */

import us from './i18n/us'
import no from './i18n/no'
import sv from './i18n/sv'
import fr from './i18n/fr'
// import dn from './i18n/dn'

/**
 * Config
 */

Vue.use(VueI18n)
/**
 * Export
 */
export default new VueI18n({
    locale: store.getters['locale'],
    fallbackLocale: 'us',
    messages: {
        us: us,
        no: no,
        se: sv,
        fr: fr,
    },
})
